let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jZbup")).then(() => parcelRequire('7STDS'));